(function () {
  var GOOGLE_G_SVG =
    '<svg class="mih-greview-card__g" width="18" height="18" viewBox="0 0 24 24" aria-label="Google review">' +
    '<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>' +
    '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>' +
    '<path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>' +
    '<path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>' +
    '</svg>';

  var mapsScriptPromise;

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      return Promise.resolve(window.google.maps);
    }
    if (mapsScriptPromise) return mapsScriptPromise;

    mapsScriptPromise = new Promise(function (resolve, reject) {
      var cbName = 'mihGoogleMapsInit_' + Date.now();
      window[cbName] = function () {
        delete window[cbName];
        resolve(window.google.maps);
      };
      var script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(apiKey) +
        '&libraries=places&loading=async&callback=' +
        cbName;
      script.async = true;
      script.defer = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return mapsScriptPromise;
  }

  function starHtml(rating, size) {
    var n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out +=
        '<svg class="mih-icon" width="' +
        size +
        '" height="' +
        size +
        '" viewBox="0 0 24 24" fill="' +
        (i <= n ? 'currentColor' : 'none') +
        '" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7L12 17.7 5.8 21.2l1.6-7L2 9.5l7.1-.6L12 2z"/></svg>';
    }
    return out;
  }

  function reviewText(review) {
    if (!review) return '';
    if (typeof review.text === 'string') return review.text;
    if (review.text && review.text.text) return review.text.text;
    if (review.originalText && review.originalText.text) return review.originalText.text;
    return '';
  }

  function reviewTitle(text) {
    if (!text) return 'Google review';
    var clean = text.replace(/\s+/g, ' ').trim();
    var first = clean.split(/[.!?]/)[0];
    if (first.length > 72) return first.slice(0, 69) + '…';
    return first || 'Google review';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildCard(review, mapsUrl) {
    var rating = review.rating || 5;
    var text = reviewText(review);
    var author = (review.authorAttribution && review.authorAttribution.displayName) || 'Google user';
    var timeAgo = review.relativePublishTimeDescription || '';
    var photoUri = review.authorAttribution && review.authorAttribution.photoURI;
    var initial = author.slice(0, 1).toUpperCase();
    var avatar = photoUri
      ? '<img class="mih-greview-card__avatar" src="' + escapeHtml(photoUri) + '" alt="' + escapeHtml(author) + '" loading="lazy" width="36" height="36">'
      : '<span class="mih-greview-card__avatar mih-greview-card__avatar--initial" aria-hidden="true">' + escapeHtml(initial) + '</span>';

    return (
      '<article class="mih-greview-card mih-greview-card--live">' +
      '<div class="mih-greview-card__top">' +
      '<div class="mih-greview-card__stars" style="color:#fbbc04">' +
      starHtml(rating, 16) +
      '</div>' +
      GOOGLE_G_SVG +
      '</div>' +
      '<h3 class="mih-greview-card__title">' +
      escapeHtml(reviewTitle(text)) +
      '</h3>' +
      '<div class="mih-greview-card__body"><p>' +
      escapeHtml(text) +
      '</p>' +
      (mapsUrl ? '<a href="' + escapeHtml(mapsUrl) + '" target="_blank" rel="noopener noreferrer" class="mih-greview-card__more">More</a>' : '') +
      '</div>' +
      '<footer class="mih-greview-card__foot">' +
      avatar +
      '<div><strong>' +
      escapeHtml(author) +
      '</strong>' +
      (timeAgo ? '<span>' + escapeHtml(timeAgo) + '</span>' : '') +
      '</div></footer></article>'
    );
  }

  function updateSummary(section, rating, count, placeId) {
    var ratingEl = section.querySelector('[data-mih-greviews-rating]');
    var starsEl = section.querySelector('[data-mih-greviews-stars]');
    var countEl = section.querySelector('[data-mih-greviews-count]');
    var ctaEl = section.querySelector('[data-mih-greviews-cta]');

    if (ratingEl && rating != null) ratingEl.textContent = Number(rating).toFixed(1);
    if (starsEl && rating != null) {
      starsEl.innerHTML = starHtml(rating, 16);
      starsEl.style.color = '#fbbc04';
    }
    if (countEl && count != null) countEl.textContent = count + ' review' + (count === 1 ? '' : 's');
    if (ctaEl && placeId) {
      ctaEl.href = 'https://search.google.com/local/writereview?placeid=' + encodeURIComponent(placeId);
    }
  }

  function initCarousel(section) {
    var rail = section.querySelector('[data-mih-greviews-rail]');
    var prev = section.querySelector('[data-mih-greviews-prev]');
    var next = section.querySelector('[data-mih-greviews-next]');
    if (!rail) return;

    function scrollByCards(direction) {
      var card = rail.querySelector('.mih-greview-card');
      var amount = card ? card.offsetWidth + 16 : 320;
      rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prev) prev.onclick = function () { scrollByCards(-1); };
    if (next) next.onclick = function () { scrollByCards(1); };
  }

  async function fetchLiveReviews(section) {
    var enabled = section.dataset.liveReviews === 'true';
    var apiKey = section.dataset.googleApiKey || '';
    var placeId = section.dataset.placeId || '';
    var placeQuery = section.dataset.placeQuery || 'Magic In Home, Narayan Vihar, Jaipur';
    var mapsUrl = section.dataset.mapsUrl || '';

    if (!enabled || !apiKey) return false;

    try {
      var maps = await loadGoogleMaps(apiKey);
      var placesLib = await maps.importLibrary('places');
      var Place = placesLib.Place;

      if (!placeId) {
        var searchResult = await Place.searchByText({
          textQuery: placeQuery,
          fields: ['id', 'displayName'],
          maxResultCount: 1
        });
        if (!searchResult.places || !searchResult.places.length) return false;
        placeId = searchResult.places[0].id;
      }

      var place = new Place({ id: placeId });
      await place.fetchFields({
        fields: ['displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsURI']
      });

      var reviews = place.reviews || [];
      if (!reviews.length) return false;

      var rail = section.querySelector('[data-mih-greviews-rail]');
      if (!rail) return false;

      var profileUrl = place.googleMapsURI || mapsUrl;
      rail.innerHTML = reviews.map(function (review) {
        return buildCard(review, profileUrl);
      }).join('');

      updateSummary(section, place.rating, place.userRatingCount, placeId);
      section.classList.add('is-live');
      return true;
    } catch (err) {
      console.warn('MIH Google Reviews: live fetch failed, using manual reviews.', err);
      return false;
    }
  }

  function initGoogleReviews() {
    document.querySelectorAll('[data-mih-greviews]').forEach(function (section) {
      initCarousel(section);
      fetchLiveReviews(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoogleReviews);
  } else {
    initGoogleReviews();
  }
})();
